var styles = {"modalTitle":"VDS__MON__modal-title-module__kiamc","dark":"VDS__MON__modal-title-module__P63jN","noCloseButton":"VDS__MON__modal-title-module__b7LSk"};

export { styles as default };
